import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.scss';
import Arrow from './Arrow';
import { FC } from 'react';

const BackButton: FC<{ link?: string }> = ({ link }: { link?: string }) => {
  const navigate = useNavigate();
  return (
    <button
      className={styles.BackButton}
      onClick={() =>
        link
          ? navigate(link, { replace: true })
          : history.length >= 2
            ? navigate(-1)
            : navigate('/')
      }
    >
      <Arrow />
      <span>Назад</span>
    </button>
  );
};

export default BackButton;
